// src/pages/Article.js
import React, { useContext, useEffect } from "react";
import { useParams } from "react-router-dom";
import { AppContext } from "../App";
import { motion } from "framer-motion";

const articles = {
  "1": {
    el: {
      title:
        "Πώς να βρείτε γρήγορα τα πιο σημαντικά έγγραφα στο gov.gr (Οδηγός 2025)",
      intro: `
Το gov.gr είναι η κεντρική ψηφιακή πύλη του Δημοσίου, με εκατοντάδες υπηρεσίες και έγγραφα διαθέσιμα online. Παρόλο που η πλατφόρμα έχει εξελιχθεί σημαντικά, πολλοί πολίτες δυσκολεύονται να εντοπίσουν γρήγορα το σωστό πιστοποιητικό ή βεβαίωση όταν τη χρειάζονται.
      `,
      sections: [
        {
          heading: "1. Φορολογικά έγγραφα (myAADE)",
          text: `
Μέσα από το myAADE μπορείτε να εκδώσετε εκκαθαριστικά Ε1, φορολογικές ενημερότητες, βεβαιώσεις αποδοχών και αποδεικτικά πληρωμής, καθώς και να ελέγξετε τρέχουσες οφειλές και ρυθμίσεις. Όλα αυτά είναι διαθέσιμα σε μορφή PDF, έτοιμα για αποστολή σε τράπεζες, εργοδότες ή άλλους φορείς.
          `,
        },
        {
          heading: "2. Πιστοποιητικά από τον δήμο",
          text: `
Πιστοποιητικά οικογενειακής κατάστασης, γέννησης, γάμου και μόνιμης κατοικίας εκδίδονται πλέον ηλεκτρονικά. Χρησιμεύουν σε αιτήσεις επιδομάτων, εγγραφές σε σχολές, δικαστικές διαδικασίες και πολλές ακόμη περιπτώσεις.
          `,
        },
        {
          heading: "3. Ασφαλιστικά & ΕΦΚΑ",
          text: `
Μέσω των ψηφιακών υπηρεσιών του ΕΦΚΑ μπορείτε να δείτε το ιστορικό ενσήμων, να εκδώσετε ασφαλιστική ενημερότητα, να παρακολουθήσετε στοιχεία σύνταξης και να εκτυπώσετε βεβαιώσεις για χρήση σε εργασία ή προκηρύξεις.
          `,
        },
        {
          heading: "4. Πώς βοηθά το VrestoEdo.gr",
          text: `
Το VrestoEdo.gr συγκεντρώνει τις πιο σημαντικές υπηρεσίες σε θεματικές κατηγορίες, με σύντομες περιγραφές και καθαρή δομή. Έτσι, αντί να ψάχνετε σε πολύπλοκα μενού, μπορείτε να φτάνετε πιο γρήγορα στην υπηρεσία που χρειάζεστε.
          `,
        },
      ],
    },
    en: {
      title:
        "How to Quickly Find the Most Important Documents on gov.gr (2025 Guide)",
      intro: `
Gov.gr is the central digital portal of the Greek public sector, offering hundreds of online services and documents. Despite its progress, many citizens still struggle to quickly find the exact certificate or document they need.
      `,
      sections: [
        {
          heading: "1. Tax documents (myAADE)",
          text: `
Through myAADE you can download income tax statements, tax clearance certificates, salary reports and payment receipts, as well as check outstanding balances. All documents are provided in PDF format and can be used for banks, employers or other authorities.
          `,
        },
        {
          heading: "2. Municipal certificates",
          text: `
Family status, birth, marriage and residence certificates are now issued digitally. They are required for benefits, school and university registrations, legal processes and many other administrative procedures.
          `,
        },
        {
          heading: "3. Insurance & EFKA",
          text: `
The EFKA online services provide access to insurance history, contribution data, insurance clearance certificates and pension–related information. These documents are essential for job applications and public sector competitions.
          `,
        },
        {
          heading: "4. How VrestoEdo.gr helps",
          text: `
VrestoEdo.gr groups the most important services into clear categories with short explanations. Instead of browsing complex menus, users can reach the exact service they need much faster.
          `,
        },
      ],
    },
  },
  "2": {
    el: {
      title: "Οι 10 πιο χρήσιμες δημόσιες υπηρεσίες για πολίτες το 2025",
      intro: `
Η Ελλάδα έχει κάνει σημαντικά βήματα στον ψηφιακό μετασχηματισμό της δημόσιας διοίκησης. Πάνω από 1.600 υπηρεσίες είναι πλέον διαθέσιμες online, διευκολύνοντας φορολογικά, ασφαλιστικά, επιδόματα, υγεία, εκπαίδευση και εργασία.
      `,
      sections: [
        {
          heading: "1. myAADE – Φορολογικές υπηρεσίες",
          text: `
Έκδοση εκκαθαριστικών, φορολογικών ενημεροτήτων, διαχείριση οφειλών και υποβολή δηλώσεων: όλα συγκεντρώνονται σε μια ενιαία πλατφόρμα, προσβάσιμη με κωδικούς Taxisnet.
          `,
        },
        {
          heading: "2. Gov.gr Wallet – Ψηφιακή ταυτότητα & δίπλωμα",
          text: `
Η ψηφιακή ταυτότητα και η άδεια οδήγησης στο κινητό έχουν μειώσει σημαντικά την ανάγκη φυσικών εγγράφων, διευκολύνοντας καθημερινές συναλλαγές σε δημόσιο και ιδιωτικό τομέα.
          `,
        },
        {
          heading: "3–9. Οι σημαντικότερες ψηφιακές υπηρεσίες",
          text: `
Από τα ασφαλιστικά του ΕΦΚΑ και τα πιστοποιητικά δημοτολογίου, μέχρι την άυλη συνταγογράφηση, τα στοιχεία οχήματος, τα επιδόματα ΟΠΕΚΑ, τις εκπαιδευτικές πλατφόρμες και τις υπηρεσίες εργασίας, οι δημόσιες υπηρεσίες καλύπτουν σχεδόν κάθε ανάγκη του πολίτη.
          `,
        },
        {
          heading: "10. Ο ρόλος του VrestoEdo.gr",
          text: `
Το VrestoEdo.gr λειτουργεί ως πύλη πλοήγησης προς αυτές τις υπηρεσίες, ομαδοποιώντας τες σε κατηγορίες με απλές περιγραφές, ώστε ο πολίτης να εντοπίζει εύκολα αυτό που χρειάζεται, χωρίς χαμένο χρόνο.
          `,
        },
      ],
    },
    en: {
      title: "The 10 Most Useful Public Services for Citizens in 2025",
      intro: `
Greece has made significant progress in digital public administration. More than 1,600 services are now available online, covering tax, insurance, benefits, health, education and employment.
      `,
      sections: [
        {
          heading: "1. myAADE – Tax services",
          text: `
Citizens can access tax statements, clearance certificates, debts and declarations through a unified platform using their Taxisnet credentials.
          `,
        },
        {
          heading: "2. Gov.gr Wallet – Digital ID and driving license",
          text: `
Digital ID and driving license on the mobile phone have greatly simplified everyday identification in both public and private transactions.
          `,
        },
        {
          heading: "3–9. Key digital services",
          text: `
From EFKA insurance records and civil registry certificates to e–prescriptions, vehicle data, OPEKA benefits, student services and employment tools, digital services now cover almost every aspect of citizens’ lives.
          `,
        },
        {
          heading: "10. The role of VrestoEdo.gr",
          text: `
VrestoEdo.gr acts as a navigation layer on top of these services, grouping them into categories with simple explanations so users can quickly find what they need.
          `,
        },
      ],
    },
  },
  "3": {
    el: {
      title:
        "Ο πλήρης οδηγός για φορολογικά, επιδόματα και πιστοποιητικά το 2025",
      intro: `
Το 2025 ο πολίτης μπορεί να καλύψει τις περισσότερες φορολογικές, ασφαλιστικές και κοινωνικές ανάγκες του εξ αποστάσεως. Από το myAADE και τον ΕΦΚΑ μέχρι τον ΟΠΕΚΑ και τα δημοτολόγια, οι υπηρεσίες έχουν περάσει σε ένα ενιαίο ψηφιακό περιβάλλον.
      `,
      sections: [
        {
          heading: "1. Φορολογικά",
          text: `
Το myAADE επιτρέπει έκδοση εκκαθαριστικών, ενημεροτήτων, βεβαιώσεων, πληρωμές οφειλών και πρόσβαση σε ιστορικά δηλώσεων. Αποτελεί βασικό εργαλείο για πολίτες, επαγγελματίες και λογιστές.
          `,
        },
        {
          heading: "2. Επιδόματα",
          text: `
ΟΠΕΚΑ και ΗΔΙΚΑ προσφέρουν πλήρως ψηφιοποιημένες διαδικασίες για επιδόματα παιδιού, ενοικίου, αναπηρίας, ανεργίας και Ελάχιστο Εγγυημένο Εισόδημα, με ηλεκτρονικές αιτήσεις και αυτόματη διασταύρωση στοιχείων.
          `,
        },
        {
          heading: "3. Πιστοποιητικά και ασφάλιση",
          text: `
Πιστοποιητικά δημοτολογίου, ληξιαρχικές πράξεις, στρατολογικά έγγραφα και ασφαλιστική ενημερότητα εκδίδονται πλέον online. Ο πολίτης μπορεί να τα κατεβάσει ή να τα αποστείλει απευθείας σε δημόσιους φορείς.
          `,
        },
        {
          heading: "4. Πώς να οργανώσετε τα έγγραφά σας",
          text: `
Η αποθήκευση των εγγράφων σε ψηφιακό φάκελο, με ταξινόμηση ανά κατηγορία (φορολογικά, επιδόματα, υγεία κ.λπ.), κάνει τη διαχείριση πολύ πιο εύκολη. Το VrestoEdo.gr μπορεί να λειτουργήσει ως σημείο εκκίνησης για να εντοπίζετε κάθε φορά την κατάλληλη υπηρεσία.
          `,
        },
      ],
    },
    en: {
      title: "A Complete Guide to Tax, Benefits and Certificates in 2025",
      intro: `
In 2025, citizens can handle most tax, insurance and social welfare procedures remotely. From myAADE and EFKA to OPEKA and municipal services, the majority of processes have moved online.
      `,
      sections: [
        {
          heading: "1. Tax",
          text: `
Through myAADE, users can issue tax statements, clearance certificates, salary reports, manage debts and review previous declarations. It is an essential tool for citizens, professionals and accountants.
          `,
        },
        {
          heading: "2. Benefits",
          text: `
OPEKA and IDIKA provide digital application processes for child benefits, rent subsidies, disability allowances, unemployment benefits and the Minimum Guaranteed Income, with automated data verification.
          `,
        },
        {
          heading: "3. Certificates and insurance",
          text: `
Civil registry certificates, military documents and insurance clearance are now issued in digital form. Citizens can download them or send them directly to other public authorities when needed.
          `,
        },
        {
          heading: "4. Organising your documents",
          text: `
Storing documents in a structured digital folder, grouped by category (tax, benefits, health, etc.), makes everyday administration much easier. VrestoEdo.gr can act as a starting point to quickly locate the right online service each time.
          `,
        },
      ],
    },
  },
};

const Article = () => {
  const { id } = useParams();
  const { language } = useContext(AppContext);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [id]);

  const articleData = articles[id];
  if (!articleData) return null;

  const t = articleData[language] || articleData.el;

  return (
    <motion.div
      className="relative min-h-screen flex flex-col items-center px-4 pt-10 pb-20 text-left"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.3 }}
    >
      <div className="absolute inset-0 bg-slate-950/80 -z-10" />

      <div className="max-w-3xl w-full">
        <h1 className="text-2xl sm:text-3xl font-bold text-white mb-6 drop-shadow-lg">
          {t.title}
        </h1>

        <p className="text-sm sm:text-base text-slate-200 mb-6 leading-relaxed">
          {t.intro.trim()}
        </p>

        <div className="space-y-6 text-sm sm:text-base text-slate-200 leading-relaxed">
          {t.sections.map((sec, idx) => (
            <section key={idx}>
              <h2 className="text-lg font-semibold text-white mb-1">
                {sec.heading}
              </h2>
              <p>{sec.text.trim()}</p>
            </section>
          ))}
        </div>
      </div>
    </motion.div>
  );
};

export default Article;